"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLineType = void 0;
var LeadServiceLineType;
(function (LeadServiceLineType) {
    LeadServiceLineType[LeadServiceLineType["Public"] = 0] = "Public";
    LeadServiceLineType[LeadServiceLineType["Private"] = 1] = "Private";
})(LeadServiceLineType = exports.LeadServiceLineType || (exports.LeadServiceLineType = {}));
//# sourceMappingURL=LeadServiceLineType.js.map